import { render } from "./CenterInfo.vue?vue&type=template&id=14b60f3a&ts=true"
import script from "./CenterInfo.vue?vue&type=script&lang=ts"
export * from "./CenterInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CenterInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14b60f3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14b60f3a', __exports__)) {
    api.reload('14b60f3a', __exports__)
  }
  
  module.hot.accept("./CenterInfo.vue?vue&type=template&id=14b60f3a&ts=true", () => {
    api.rerender('14b60f3a', render)
  })

}


export default __exports__